import React from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import AssignedToColumn from '../../../components/columns/assigned-to-column';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const AssignedToColumnShippingGrid = ({ fulfillmentId }) => {
  const { fulfillmentPlanId } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};

  const assignedToUserId = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'assignedToUserId',
    }),
  );

  if (!assignedToUserId) {
    return '';
  }
  return <AssignedToColumn userId={assignedToUserId} />;
};

AssignedToColumnShippingGrid.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const AssignedTo = {
  getMessageDescriptor: () => messages.assignedTo,
  id: 'assignedTo',

  render: (data) => {
    return <AssignedToColumnShippingGrid fulfillmentId={data.id} />;
  },
};
